import { useQuery } from '@tanstack/react-query';
import type { CookieConsentConfig } from '@/components/cookie-consent/types';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const API_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;

export function useCookieConsentConfig(brandId: string | null) {
  return useQuery({
    queryKey: ['cookie-consent-config', brandId],
    queryFn: async (): Promise<CookieConsentConfig | null> => {
      if (!brandId || !SUPABASE_URL) return null;
      const url = `${SUPABASE_URL}/functions/v1/cms-plugins-api/plugins/cookie-consent/config?brand_id=${encodeURIComponent(brandId)}`;
      const res = await fetch(url, { headers: { apikey: API_KEY || '' } });
      if (!res.ok) {
        if (res.status === 404) return null;
        throw new Error('Failed to load cookie consent config');
      }
      const data = await res.json();
      return data.success ? data : null;
    },
    enabled: !!brandId,
    staleTime: 5 * 60 * 1000,
  });
}
